import type { UploadChannel, UploadTask } from '../types/uploads';

/** A stable lifecycle signature for history invalidation. Byte/speed changes are deliberately absent,
 * so chunk progress cannot turn the by-uploader list endpoint into a high-frequency poll. */
export function uploadHistorySignature(
  items: readonly UploadTask[],
  channel: UploadChannel,
): string {
  return items
    .filter((item) => item.channel === channel && item.backendId)
    .map((item) => `${item.backendId}:${item.phase}`)
    .sort()
    .join('|');
}
